import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function IsThisForYouSection() {
  const checklistItems = ["You claimed Social Security before your Full Retirement Age and wish you hadn't.", "You're worried the check you locked in won't keep up with inflation over the next 20 years.", "You've been told \"there's nothing you can do\" — but something in your gut says that can't be right.", 'You want to make sure your wife is protected if something happens to you.', "You're willing to spend 15 minutes reading a guide if it means potentially adding $100,000+ to your lifetime income."];
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8
  }} className="my-16 space-y-8" data-id="element-117">
      <h3 className="text-2xl md:text-3xl font-bold text-[#1B2A4A] text-center md:text-left" data-id="element-118">
        This Guide Was Written For You If...
      </h3>

      <ul className="space-y-4" data-id="element-119">
        {checklistItems.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-120">
            <div className="flex-shrink-0 mt-1" data-id="element-121">
              <CheckIcon className="w-5 h-5 text-[#D4652A]" strokeWidth={3} data-id="element-122" />
            </div>
            <p className="ml-4 text-lg text-[#1B2A4A]" data-id="element-123">{item}</p>
          </li>)}
      </ul>

      <p className="text-lg text-[#1B2A4A]/70 italic border-t border-[#1B2A4A]/10 pt-6 mt-6" data-id="element-124">
        It doesn&apos;t matter if you claimed last month or five years ago. At
        least one of the three exits in this guide likely applies to your
        situation.
      </p>
    </motion.section>;
}